import ReactApexChart from "react-apexcharts";
import { Skeleton, Stack } from "@mui/material";
import styles from "../../../styles/charts/chartStyle.module.css";
import { ApexOptions } from "apexcharts";
import { toShortNumber } from "../../../lib/util";

interface PieChartProps {
  title?: string;
  labels: any[];
  chartData: any;
  type?: "pie" | "donut";
}
export const PieChart = (props: PieChartProps) => {
  const { type = "pie", title } = props;

  let options = {
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: "xLabel",
            headerValue: "yLabel",
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },
    colors: [
      "#008FFB",
      "#01E396",
      "#FEB019",
      "#FF4560",
      "#775DD0",
      // "#3b81f1",
      "#ccccff",
      "#7fdfff",
      "#81a432",
      "#68228b",
      "#00563f",
      "#674937",
      "#621b18",
      "#68228b",
    ],
    // title: {
    //   text: props.title,
    //   offsetY: 0,
    //   align: "center" as "center",
    //   style: {
    //     color: "#000000",
    //     fontWeight: "500",
    //     fontSize: "18px",
    //   },
    // },
    dataLabels: {
      enabled: true,
    },
    labels: props.labels,
    responsive: [
      {
        breakpoint: 350,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      width: 150,
    },
    tooltip: {
      y: {
        // show: false,
        formatter: (value: any) => {
          // console.log(value);
          return `$${toShortNumber(value)}`;
        },
      },
    },
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };
  let data = props.chartData;

  return (
    <>
      <div style={{ width: "100%" }}>
        <ReactApexChart
          className={styles.the_pie_chart}
          options={options as unknown as ApexOptions}
          series={data}
          type={type}
          height={1000}
        />
      </div>
    </>
  );
};

export const PieChartLoading = () => {
  return (
    <div className="horizontalCenter">
      {/* <Skeleton variant="text" height="50px" width={250} /> */}
      <Stack direction="row">
        <Skeleton variant="circular" width={300} height={300} />
        {/* <Skeleton variant="rectangular" width={120} height={150} /> */}
      </Stack>
    </div>
  );
};
